var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"soldout-page inner"},[_c('site-menu',{staticClass:"menu",attrs:{"theme":"dark"}}),_c('h1',[_vm._v("Item Sold Out")]),_c('divider'),_c('illustration')],1)}
var staticRenderFns = []

export { render, staticRenderFns }